export default "__VITE_ASSET__Rwy7nlEl__"